/**
 *  @class
 *  @function Pagination
 *  Tones fix (Oct 2026): infinite scroll starts loading ~1200px before the bottom,
 *  re-checks after each load, and stops cleanly at the last page.
 */
if (!customElements.get('pagination-theme')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
      this.finished = false;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;
      if (search) {
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);
        if (params === search) {
          params += '&' + newParam;
        }
      }
      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          base.loadProducts();
        }
      }, {
        rootMargin: '0px 0px 1200px 0px'
      });
      base.observer.observe(base);
    }
    recheck() {
      if (this.observer && !this.finished) {
        this.observer.unobserve(this);
        this.observer.observe(this);
      }
    }
    stop() {
      this.finished = true;
      if (this.observer) {
        this.observer.unobserve(this);
      }
      this.removeAttribute('loading');
      if (this.button) {
        this.button.classList.add('visually-hidden');
      }
    }
    loadProducts() {
      let base = this;
      if (base.finished || base.getAttribute('loading')) {
        return;
      }
      let url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      base.i++;
      base.setAttribute('loading', true);
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          base.renderProducts(responseText, url);
          if (typeof dispatchCustomEvent === 'function') {
            dispatchCustomEvent('pagination:page-changed', { url: url });
          }
        })
        .catch(() => {
          base.removeAttribute('loading');
        });
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
      if (!grid_to_replace) {
        base.stop();
        return;
      }
      let products = grid_to_replace.querySelectorAll('.column');
      if (!products.length) {
        base.stop();
        return;
      }
      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
      }
      const done = function () {
        base.removeAttribute('loading');
        if (typeof StampedFn !== 'undefined' && typeof StampedFn.loadBadges === 'function') {
          StampedFn.loadBadges();
        }
        setTimeout(function () { base.recheck(); }, 100);
      };
      if (this.animations_enabled) {
        gsap.set(products, { opacity: 0, y: 30 });
        gsap.to(products, { duration: 0.5, y: 0, opacity: 1, stagger: 0.05, onComplete: done });
      } else {
        done();
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}
